// removed by extract-text-webpack-plugin
module.exports = {"modal-footer":"styles-module__modal-footer___3tHO_","demo-button":"styles-module__demo-button___CVp91","demo-screenshot":"styles-module__demo-screenshot___2SGJl"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/Modal/StartModal/styles.module.css
// module id = 391
// module chunks = 0